import { createContext, useContext } from 'react';
import { DefaultStorage } from 'shared/tools';

export const ConsumerCodeStorageContext = createContext<DefaultStorage>(undefined!);

export function useConsumerCodeStorage() {
  return useContext(ConsumerCodeStorageContext);
}
